// src/store/bracket/reducers/bracketReducer.js

import * as actionTypes from "../actions/actionTypes";

const initialState = {
  BracketData: [],
  BracketDetails: null,
  BracketsByDivision: [],
  currentBracket: null,
  isLoading: false,
};

const BracketReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actionTypes.GET_BRACKETS:
      return {
        ...state,
        BracketData: action.payload?.data || [],
        isLoading: false,
      };

    case actionTypes.GET_BRACKET_BY_ID:
      return {
        ...state,
        BracketDetails: action.payload?.data || null,
        currentBracket: action.payload?.data || null,
        isLoading: false,
      };

    case actionTypes.GET_BRACKETS_BY_DIVISION:
      return {
        ...state,
        BracketsByDivision: action.payload?.data || [],
        isLoading: false,
      };

    case actionTypes.CREATE_BRACKET:
      return {
        ...state,
        currentBracket: action.payload,
        isLoading: false,
      };

    case actionTypes.GENERATE_BRACKET:
      return {
        ...state,
        currentBracket: action.payload,
        BracketDetails: action.payload,
        isLoading: false,
      };

    case actionTypes.UPDATE_GAME_RESULT:
      return {
        ...state,
        currentBracket: action.payload,
        BracketDetails: action.payload,
        isLoading: false,
      };

    case actionTypes.UPDATE_BRACKET_STATUS:
      return {
        ...state,
        currentBracket: action.payload,
        BracketDetails: action.payload,
        isLoading: false,
      };

    case actionTypes.DELETE_BRACKET:
      return {
        ...state,
        BracketData: state.BracketData.filter(
          (bracket) => bracket.bracketId !== action.payload
        ),
        BracketsByDivision: state.BracketsByDivision.filter(
          (bracket) => bracket.bracketId !== action.payload
        ),
        isLoading: false,
      };

    case actionTypes.CLEAR_BRACKET:
      return {
        BracketData: [],
        BracketDetails: null,
        BracketsByDivision: [],
        currentBracket: null,
        isLoading: false,
      };


          // ⭐ NEW: mirrors UPDATE_BRACKET_STATUS, plus patches the bracket's
    // status in BracketsByDivision so the cards grid reflects PUBLISHED
    // immediately without a full refetch.
    case actionTypes.PUBLISH_BRACKET: {
      const publishedBracket = action.payload?.data;
      return {
        ...state,
        currentBracket: publishedBracket,
        BracketDetails: publishedBracket,
        BracketsByDivision: state.BracketsByDivision.map((b) =>
          b.bracketId === publishedBracket?.bracketId ? publishedBracket : b
        ),
        isLoading: false,
      };
    }

    default:
      return state;
  }
};

export default BracketReducer;